export default "__VITE_ASSET__Dm93iQ28__"